import { WalletIndicatorTranslations } from "./wallet-indicator-pt-br";

export const WALLET_INDICATOR_FR_FR: WalletIndicatorTranslations = {
	wallet: "Portefeuille",
	totalBalance: "Solde total",
	withdrawal: "Disponible pour retrait",
	anticipation: "Disponible pour anticipation",
	anticipationSmDevice: "Disponible pour anticipation",
	anticipationTooltip:
		"Valeurs des transactions par carte de crédit qui n'ont pas encore été liquidées.",
	seeWallet: "Voir Portefeuille",
	yourAccounts: "Vos comptes",
	blockedBalance: "Valeur Bloquée",
	blockedBalanceTooltip:
		"Valeurs retenues par Zig pour des raisons opérationnelles, entrées futures, transferts au Vendor et autres blocages.",
	blockedByPendingWithdraws: "Retraits en cours",
	blockedByPendingWithdrawsTooltip:
		"La valeur totale correspond aux demandes de retrait en cours de traitement par Zig",
};
